module.exports = __webpack_public_path__ + "static/empty-state-value-props-obvious-do-c8ef25a6fed62876b71d8bb1d75f726a.png";